/**
 * @author      Shivani Mehra
 * @date        Oct, 2025
 * @copyright   www.ibirdsservices.com
 */

import React, { useEffect, useRef, useState } from 'react';
import {
  Card,
  Col,
  Container,
  Form,
  Row,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Badge, Button, Dropdown } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import moments from 'moment-timezone';
import { toast } from 'react-toastify';
import WatconnectApi from '../../../api/WatconnectApi';
import Confirm from '../../Confirm';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const Templateview = ({ selectedWhatsAppSetting }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState(
    location.state ? location.state : {}
  );
  console.log('templateData', templateData);
  // Unix timestamp ko readable date format me convert karne ke liye:

  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
  const [templateDelete, setTemplateDelete] = useState(false);
  const [rowData, setRowData] = useState();
  const [formattedData, setFormattedData] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileURL, setSelectedFileURL] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const docxIcon = '/user_images/doc-icon.png';
  const fileInputRef = useRef(null);

  const [dateRange, setDateRange] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);

  // console.log("templateData->", templateData);
  useEffect(() => {
    //setParameters({});

    if (templateData && typeof tamplateparms === 'object') {
      const {
        sendToAdmin,
        file,
        file_id,
        whatsapp_number_admin,
        ...restParameters
      } = templateData;
      if (file) {
        setSelectedFile(file);
        setSelectedFileType(file.type);
        setSelectedFileURL(URL.createObjectURL(file));
      }
    }
  }, [templateData]);
  const renderFormattedMessage = () => {
    const formatted = templateData?.message_body;
    return (
      <div
        className='p-2'
        style={{
          background: '#fff',
          borderRadius: '8px',
          color: '#222',
          lineHeight: 1.6,
          wordBreak: 'break-word',
        }}
        dangerouslySetInnerHTML={{ __html: formatted }}
      />
    );
  };

  // Replace placeholders like {{1}}, {{2}} with sample values dynamically
  const replaceTemplateVariables = text => {
    if (!text) return '';
    let replaced = text;
    let index = 1;
    replaced = replaced.replace(/{{\d+}}/g, () => {
      return `<span class='text-primary fw-bold'>Sample ${index++}</span>`;
    });
    replaced = replaced.replace(/\n/g, '<br/>');
    replaced = replaced.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
    return replaced;
  };
  const getHeader = () => {
    if (!templateData?.header) return null;

    switch (templateData.header) {
      case 'IMAGE':
        return (
          <img
            src={templateData.header_image_url}
            alt='Header'
            className='img-fluid rounded w-100 mb-2'
            style={{ height: '200px', objectFit: 'cover' }}
          />
        );
      case 'VIDEO':
        return (
          <video
            src={templateData.header_video_url}
            controls
            className='img-fluid rounded w-100 mb-2'
            style={{ height: '200px', objectFit: 'cover' }}
          />
        );
      case 'DOCUMENT':
        return (
          <a
            href={templateData.header_document_url}
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={docxIcon}
              alt='Document Thumbnail'
              className='img-fluid rounded w-100 mb-2'
              style={{ height: '200px', objectFit: 'cover' }}
            />
          </a>
        );
      default:
        return (
          <div className='fw-semibold text-dark mb-2 text-center'>
            {templateData.header_text || ''}
          </div>
        );
    }
  };

  const getFooter = () =>
    templateData.footer ? (
      <div
        className='template-footer mt-3 text-muted small text-center'
        style={{ borderTop: '1px solid #eee', paddingTop: '6px' }}
      >
        {templateData.footer}
      </div>
    ) : null;

  const getButtons = () => {
    if (!templateData.buttons?.length) return null;
    return (
      <div
        className='mt-3 d-flex flex-wrap justify-content-center gap-2'
        style={{
          borderTop: '1px solid #eee',
          paddingTop: '10px',
        }}
      >
        {templateData.buttons.map((btn, i) => {
          const commonStyle = {
            minWidth: '45%',
            flex: '1 1 auto',
            fontWeight: 500,
          };

          if (btn.type === 'PHONE_NUMBER') {
            return (
              <Button
                key={i}
                variant='success'
                style={commonStyle}
                href={`tel:${btn.phone_number}`}
              >
                {btn.text}
              </Button>
            );
          } else if (btn.type === 'URL') {
            return (
              <Button
                key={i}
                variant='primary'
                style={commonStyle}
                href={btn.url}
                target='_blank'
              >
                {btn.text}
              </Button>
            );
          } else if (btn.type === 'QUICK_REPLY') {
            return (
              <Button key={i} variant='outline-secondary' style={commonStyle}>
                {btn.text}
              </Button>
            );
          }
          return null;
        })}
      </div>
    );
  };

  const handleBack = () => {
    navigate('/watconnect/templates');
  };
  const closeCalendar = () => {
    setShowCalendar(false);
  };
  const removeSelectedRow = data => {
    setTemplateDelete(true);

    setRowData(data?.templateData);
  };
  const deleteTemplate = async () => {
    if (rowData.id && rowData.name) {
      const watconnectApi = new WatconnectApi('webhook_template');

      const result = await watconnectApi.deleteUrl(
        `/template?hsm_id=${rowData.id}&name=${rowData.name}&whatsapp_setting_number=${selectedWhatsAppSetting}`
      );
      if (result.success) {
        setTemplateDelete(false);
        //toast.success('Template deleted successfully.');
        navigate('/watconnect/templates');
        //setTimeout(() => {
        //}, 2000);
        //fetchAllTemplates(selectedWhatsAppSetting);
      } else {
        setTemplateDelete(false);
        //toast.error(result.error.message);
      }
    }
  };

  const handleSelect = ranges => {
    setDateRange([ranges.selection]);
  };

  const selectDate = () => {
    setShowCalendar(false);
    let firstdate = moments(dateRange[0].startDate)
      .tz('Asia/Kolkata')
      .startOf('day')
      .unix();
    let lastdate = moments(dateRange[0].endDate)
      .tz('Asia/Kolkata')
      .endOf('day')
      .unix();
    init(firstdate, lastdate);
  };

  useEffect(() => {
    const currentTime = moment().tz('Asia/Kolkata').unix(); // Current timestamp
    const ninetyDaysAgo = currentTime - 90 * 24 * 60 * 60; // 90 days ago

    let firstdate = Math.max(
      moment().tz('Asia/Kolkata').startOf('month').unix(),
      ninetyDaysAgo
    );
    let lastdate = Math.min(
      moment().tz('Asia/Kolkata').endOf('month').unix(),
      currentTime
    );

    setDateRange([
      {
        startDate: moment.unix(firstdate).format(),
        endDate: moment.unix(lastdate).format(),
        key: 'selection',
      },
    ]);

    init(firstdate, lastdate);
    setIsSpinner(false);
  }, [selectedWhatsAppSetting]);

  async function init(start = '', end = '') {
    setIsSpinner(false);
    const watconnectApi = new WatconnectApi('whatsapp_setting');

    const billData = await watconnectApi.get(
      `/templateprice/${templateData?.templateid}/${selectedWhatsAppSetting}/${start}/${end}`
    );
    console.log(billData);
    //const billData = { success: false };

    if (billData.success) {
      let totalAmountSpent = 0;
      let totalCostPerDelivered = 0;
      let totalSent = 0;
      let totalDelivered = 0;
      let totalRead = 0;
      const formattedData = billData.result.map(item => ({
        date: new Date(item.start * 1000).toLocaleDateString(),
        sent: item.sent || 0,
        delivered: item.delivered || 0,
        read: item.read || 0,
      }));
      setFormattedData(formattedData);
      // console.log("billData",billData);
      billData.result.forEach(record => {
        totalSent += record.sent || 0;
        totalDelivered += record.delivered || 0;
        totalRead += record.read || 0;
        record?.cost?.forEach(cost => {
          if (cost.type === 'amount_spent' && cost.value) {
            totalAmountSpent += cost.value;
          }
          //if (cost.type === 'cost_per_delivered' && cost.value) {
          //    totalCostPerDelivered += cost.value;//only one time
          //}
        });
        const costPerDelivered = record?.cost?.find(
          cost => cost.type === 'cost_per_delivered' && cost.value
        );
        if (costPerDelivered) {
          totalCostPerDelivered = costPerDelivered.value;
        }
      });
      setBody({
        totalSent,
        totalDelivered,
        totalRead,
        totalAmountSpent: totalAmountSpent.toFixed(2),
        totalCostPerDelivered: totalCostPerDelivered.toFixed(2),
      });

      setIsSpinner(true);
    } else {
      setBody([]);
    }
  }

  const editTemplate = data => {
    navigate(`/template/add`, { state: data?.templateData });
  };

  // --- Carousel Template Detection ---
  const isCarouselTemplate =
    templateData?.template_type === 'carousel' ||
    (templateData?.components &&
      templateData.components.some(c => c.type === 'carousel'));

  // --- Carousel Card Renderer ---
  const renderCarouselCards = () => {
    // Get cards from either DB or API structure
    let cards = [];
    //console.log("templateData.cards",templateData.cards)
    if (templateData.cards && Array.isArray(templateData.cards)) {
      //console.log("Raw DB cards:", templateData.cards);
      cards = templateData.cards.map(card => {
        // Robust header_image_url mapping
        let header_image_url =
          card.header_image_url ||
          card.header?.image_url ||
          (card.header?.handle && /^https?:\/\//.test(card.header.handle)
            ? card.header.handle
            : '') ||
          (card.header_type === 'IMAGE' &&
            card.header_handle &&
            /^https?:\/\//.test(card.header_handle)
            ? card.header_handle
            : '');

        let header_video_url =
          card.header_video_url ||
          card.header?.video_url ||
          (card.header_type === 'VIDEO' &&
            card.header_handle &&
            /^https?:\/\//.test(card.header_handle)
            ? card.header_handle
            : '');

        const mapped = {
          header_type: card.header_type || card.header?.format || 'IMAGE',
          header_handle: card.header_handle || card.header?.handle || '',
          header_image_url,
          header_video_url,
          body_text: card.body_text || card.body?.text || '',
          buttons: card.buttons || [],
          body_text_example: card.body_text_example || card.body?.example || [],
        };
        //console.log("Mapped DB card:", mapped);
        return mapped;
      });
    } else if (templateData.components) {
      const carouselComp = templateData.components.find(
        c => c.type === 'carousel'
      );
      if (carouselComp && Array.isArray(carouselComp.cards)) {
        //console.log("Raw API cards:", carouselComp.cards);
        cards = carouselComp.cards.map(card => {
          const header = card.components.find(c => c.type === 'header');
          const body = card.components.find(c => c.type === 'body');
          const buttons = card.components.find(c => c.type === 'buttons');
          let header_image_url = header?.image_url || '';
          if (
            !header_image_url &&
            header?.example?.header_handle?.[0] &&
            /^https?:\/\//.test(header.example.header_handle[0])
          ) {
            header_image_url = header.example.header_handle[0];
          }
          const mapped = {
            header_type: header?.format || 'image',
            header_handle: header?.example?.header_handle?.[0] || '',
            header_image_url,
            body_text: body?.text || '',
            buttons: buttons?.buttons || [],
            body_text_example: body?.example?.body_text?.[0] || [],
          };
          //console.log("Mapped API card:", mapped);
          return mapped;
        });
      }
    }
    if (!cards.length) return null;
    return (
      <div
        style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: 16 }}
      >
        {cards.map((card, idx) => (
          <div
            key={idx}
            style={{
              display: 'inline-block',
              width: 320, // increased from 300
              marginRight: 16,
              verticalAlign: 'top',
            }}
          >
            <Card className='shadow-sm' style={{ minHeight: 250 }}>
              <Card.Body>
                {/* Header image */}
                {card.header_type === 'IMAGE' && card.header_image_url && (
                  <img
                    src={card.header_image_url}
                    alt='Card'
                    className='img-fluid rounded w-100 mb-2'
                    style={{ height: '160px', objectFit: 'cover' }}
                  />
                )}

                {card.header_type === 'VIDEO' && card.header_video_url && (
                  <video
                    src={card.header_video_url}
                    controls
                    className='rounded w-100 mb-2'
                    style={{ height: '160px', objectFit: 'cover' }}
                  />
                )}
                {/* Card body text */}
                <div
                  className='mb-2'
                  style={{
                    minHeight: 48,
                    fontWeight: 500,
                    fontSize: '1rem',
                    color: '#222',
                    padding: '8px 0',
                    background: '#f8f9fa',
                    borderRadius: '4px',
                    wordBreak: 'break-word',
                    marginTop: '8px',
                    whiteSpace: 'normal', // ensure text wraps
                  }}
                >
                  {card.body_text}
                </div>
                {/* Body text variable examples */}
                {card.body_text_example &&
                  card.body_text_example.length > 0 && (
                    <div className='mb-2'>
                      <strong>Examples:</strong>
                      <ul>
                        {card.body_text_example.map((ex, i) => (
                          <li key={i}>{ex}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                {/* Buttons */}
                <div>
                  {card.buttons &&
                    card.buttons.map((btn, bidx) => (
                      <div key={bidx} className='mb-1'>
                        {btn.type === 'QUICK_REPLY' && (
                          <Button
                            size='sm'
                            variant='outline-primary'
                            style={{ width: '100%' }}
                          >
                            {btn.text}
                          </Button>
                        )}
                        {btn.type === 'URL' && (
                          <div>
                            <Button
                              size='sm'
                              variant='outline-success'
                              style={{ width: '100%' }}
                              href={btn.url || '#'}
                              target='_blank'
                            >
                              {btn.text}
                            </Button>
                            {btn.example && (
                              <div
                                style={{ fontSize: '0.85em', color: '#888' }}
                              >
                                Example: {btn.example}
                              </div>
                            )}
                          </div>
                        )}
                        {btn.type === 'PHONE_NUMBER' && (
                          <Button
                            size='sm'
                            variant='outline-info'
                            style={{ width: '100%' }}
                          >
                            {btn.text}
                          </Button>
                        )}
                      </div>
                    ))}
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <Container className='mt-5'>
        <Row className='mx-5 section-header border-bottom pb-3'>
          <Col lg={12}>
            <Row className='align-items-center justify-content-between'>
              {/* Left Side - Category */}
              <Col lg={6} sm={12} xs={12} className='d-flex align-items-center'>
                <div className='me-4'>
                  <div className='fw-bold'>Template</div>
                  <span>{templateData?.category}</span>
                </div>
              </Col>

              {/* Right Side - Date Range and Buttons */}
              <Col
                lg={6}
                sm={12}
                xs={12}
                className='d-flex justify-content-end align-items-center'
              >
                <div
                  className='position-relative me-2'
                  style={{ minWidth: '280px' }}
                >
                  <Form.Group className='d-flex align-items-center'>
                    <Form.Control
                      type='text'
                      readOnly
                      className='border p-2 cursor-pointer form-control'
                      value={`${moment(dateRange[0]?.startDate).format(
                        'DD/MM/YYYY'
                      )} - ${moment(dateRange[0]?.endDate).format(
                        'DD/MM/YYYY'
                      )}`}
                      onClick={() => setShowCalendar(!showCalendar)}
                      style={{ width: '100%' }}
                    />
                  </Form.Group>

                  {showCalendar && (
                    <div ref={calendarRef} className='calendar-wrapper'>
                      <Card bg='light' className='shadow'>
                        <Card.Body>
                          <DateRangePicker
                            showSelectionPreview={true}
                            ranges={dateRange}
                            onChange={handleSelect}
                            direction='horizontal'
                            months={2}
                            moveRangeOnFirstSelection={false}
                            maxDate={new Date()}
                            minDate={
                              new Date(
                                new Date().setDate(new Date().getDate() - 88)
                              )
                            }
                          />
                        </Card.Body>
                        <Card.Footer className='text-end'>
                          <Button className='me-2' onClick={closeCalendar}>
                            Close
                          </Button>
                          <Button onClick={selectDate}>Select Date</Button>
                        </Card.Footer>
                      </Card>
                    </div>
                  )}
                </div>

                <Button
                  className='btn-sm me-2'
                  variant='outline-light'
                  onClick={handleBack}
                >
                  Back
                </Button>
                <Button
                  className='btn-sm me-2'
                  variant='light'
                  onClick={() => editTemplate({ templateData })}
                >
                  Edit
                </Button>
                <Button
                  className='btn-sm'
                  variant='danger'
                  onClick={() => removeSelectedRow({ templateData })}
                >
                  Delete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {isSpinner ? (
        <Container className='mt-5'>
          <Row className='mx-5 pb-3'>
            <div className='col-md-4'>
              <Card className='shadow'>
                <Card.Body>
                  <div className='whatsapp-background w-100'>
                    <div className='template-box'>
                      {/* Carousel or normal template rendering */}
                      {isCarouselTemplate ? (
                        <>
                          {/* Main message body */}
                          <div className='template-content mt-3 mb-3'>
                            {templateData?.message_body}
                          </div>
                          {/* Carousel cards */}
                          {renderCarouselCards()}
                        </>
                      ) : (
                        <>
                          {getHeader()}
                          <div
                            className='template-content mt-3 p-3 rounded'
                            style={{
                              background: '#fdfdfd',
                              border: '1px solid #eee',
                              borderRadius: '10px',
                              boxShadow: 'inset 0 0 6px rgba(0,0,0,0.05)',
                            }}
                          >
                            {renderFormattedMessage()}
                            {getFooter()}
                            {getButtons()}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className='col-md-8'>
              <div className='row g-4'>
                <div className='col-md-6'>
                  <Card className='text-center shadow-sm'>
                    <Card.Body>
                      <Card.Title className='fw-bold'>
                        Amount spent
                        <OverlayTrigger
                          placement='auto'
                          overlay={
                            <Popover id={`popover-positioned-auto`}>
                              <Popover.Body>
                                The total amount spent on message templates,
                                with costs attributed to the first template sent
                                in a 24-hour conversation window. Data is
                                available 1 hour after enabling performance
                                insights.
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <i
                            className='fa-solid fa-circle-info text-secondary ms-1'
                            style={{ cursor: 'pointer' }}
                          ></i>
                        </OverlayTrigger>
                      </Card.Title>

                      <p className='display-6 fw-semibold mt-2'>
                        ₹{body.totalAmountSpent}
                      </p>
                    </Card.Body>
                  </Card>
                </div>

                <div className='col-md-6'>
                  <Card className='text-center shadow-sm'>
                    <Card.Body>
                      <Card.Title className='fw-bold'>
                        Cost per message delivered{' '}
                        <OverlayTrigger
                          placement='auto'
                          overlay={
                            <Popover id={`popover-positioned-auto`}>
                              <Popover.Body>
                                Cost per message is calculated by dividing the
                                amount spent by the messages delivered within 7
                                days. Data is available 1 hour after enabling
                                performance insights.{' '}
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <i
                            className='fa-solid fa-circle-info text-secondary ms-1'
                            style={{ cursor: 'pointer' }}
                          ></i>
                        </OverlayTrigger>
                      </Card.Title>
                      <p className='display-6 fw-semibold mt-2'>
                        ₹{body.totalCostPerDelivered}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              </div>

              <Card className='mt-4 shadow-sm'>
                <Card.Body>
                  <Card.Title className='fw-bold mb-3'>Performance</Card.Title>
                  <div className='row text-center'>
                    <div className='col-md-4'>
                      <h6 className='text-muted'>Messages sent</h6>
                      <p className='h4 fw-semibold'>{body?.totalSent}</p>
                    </div>
                    <div className='col-md-4'>
                      <h6 className='text-muted'>Messages delivered</h6>
                      <p className='h4 fw-semibold'>{body?.totalDelivered}</p>
                    </div>
                    <div className='col-md-4'>
                      <h6 className='text-muted'>Messages read</h6>
                      <p className='h4 fw-semibold'>{body?.totalRead}</p>
                    </div>
                  </div>

                  <div
                    className='mt-4 bg-light d-flex align-items-center justify-content-center rounded'
                    style={{ height: '200px' }}
                  >
                    {/*<p className="text-muted">Graph Placeholder</p>*/}
                    <ResponsiveContainer width='100%'>
                      <LineChart data={formattedData}>
                        <CartesianGrid strokeDasharray='3 3' />
                        <XAxis dataKey='date' />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type='monotone'
                          dataKey='sent'
                          stroke='#ff4d4f'
                          name='Messages Sent'
                        />
                        <Line
                          type='monotone'
                          dataKey='delivered'
                          stroke='#722ed1'
                          name='Messages Delivered'
                        />
                        <Line
                          type='monotone'
                          dataKey='read'
                          stroke='#52c41a'
                          name='Messages Read'
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Row>
        </Container>
      ) : (
        <div className='sk-cube-grid'>
          <div className='sk-cube sk-cube1'></div>
          <div className='sk-cube sk-cube2'></div>
          <div className='sk-cube sk-cube3'></div>
          <div className='sk-cube sk-cube4'></div>
          <div className='sk-cube sk-cube5'></div>
          <div className='sk-cube sk-cube6'></div>
          <div className='sk-cube sk-cube7'></div>
          <div className='sk-cube sk-cube8'></div>
          <div className='sk-cube sk-cube9'></div>
        </div>
      )}
      {templateDelete && (
        <Confirm
          show={templateDelete}
          onHide={() => setTemplateDelete(false)}
          deleteTemplate={deleteTemplate}
          title='Confirm Delete'
          message='You are going to delete the record. Are you sure?'
          table='template'
        />
      )}
    </>
  );
};

export default Templateview;
